import { useTranslation } from 'next-i18next'
import Reveal from '../../home-new/Reveal'
import styles from './OurGoals.module.scss'

// "เป้าหมายของเรา" — left: CENTER-aligned heading + highlighted pill
// statement + paragraph; right: 3 stacked feature rows. Column split 7:5,
// both columns top-align. Styling migrated from makeStyles to a static CSS
// Module.
const OurGoals = () => {
  const { t } = useTranslation('about-us')

  const goals = [
    {
      icon: 'goal-easier',
      w: 86,
      h: 72,
      title: t('about.new.goals.items.easier.title'),
      desc: t('about.new.goals.items.easier.desc'),
    },
    {
      icon: 'goal-connect',
      w: 76,
      h: 76,
      title: t('about.new.goals.items.connect.title'),
      desc: t('about.new.goals.items.connect.desc'),
    },
    {
      icon: 'goal-grow',
      w: 87,
      h: 62,
      title: t('about.new.goals.items.grow.title'),
      desc: t('about.new.goals.items.grow.desc'),
    },
  ]

  return (
    <section className={styles.root}>
      <div className={styles.container}>
        <div className={styles.gridContainer}>
          <div className={styles.gridItemMd7}>
            <div className={styles.copyCol}>
              <Reveal direction="left">
                <h2 className={styles.heading}>
                  <span>{t('about.new.goals.heading-highlight')}</span>
                  {t('about.new.goals.heading-suffix')}
                </h2>
              </Reveal>
              <Reveal direction="left" delay={0.08}>
                <p className={styles.tagline}>
                  {t('about.new.goals.tagline')}
                </p>
              </Reveal>
              <Reveal direction="left" delay={0.16}>
                <p className={styles.desc}>{t('about.new.goals.desc')}</p>
              </Reveal>
            </div>
          </div>
          <div className={styles.gridItemMd5}>
            <div className={styles.rowStack}>
              {goals.map((goal, i) => (
                <Reveal key={goal.title} direction="right" delay={i * 0.1}>
                  <div className={styles.row}>
                    <picture style={{ display: 'contents' }}>
                      <source
                        srcSet={`/static/img/about-us-new/${goal.icon}.webp`}
                        type="image/webp"
                      />
                      <img
                        src={`/static/img/about-us-new/${goal.icon}.png`}
                        alt=""
                        className={styles.icon}
                        width={goal.w}
                        height={goal.h}
                        loading="lazy"
                        decoding="async"
                      />
                    </picture>
                    <div>
                      <h3 className={styles.rowTitle}>{goal.title}</h3>
                      <p className={styles.rowDesc}>{goal.desc}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default OurGoals
